import { TZDate } from '@date-fns/tz';
import { CustomDateFormats, NoddiDateFormats, noddiFormatDate } from '../date/date';

type TimeWindowForDisplay = {
  startsAt: string;
  endsAt: string;
  timeZone: { value: string; label: string };
};

type BookingTimeWindowDisplayOptions = {
  timeWindow: TimeWindowForDisplay;
  withEndTime?: boolean;
  startDateFormat?: NoddiDateFormats | CustomDateFormats;
};

export const getBookingTimeWindowDisplayParts = ({
  timeWindow,
  withEndTime = true,
  startDateFormat = NoddiDateFormats.DATE
}: BookingTimeWindowDisplayOptions): { date: string; timeRange: string } => {
  const startDate = new TZDate(timeWindow.startsAt, timeWindow.timeZone.value);
  const endDate = new TZDate(timeWindow.endsAt, timeWindow.timeZone.value);
  const timeRange = withEndTime
    ? `${noddiFormatDate(startDate, NoddiDateFormats.TIME)} - ${noddiFormatDate(endDate, NoddiDateFormats.TIME)}`
    : noddiFormatDate(startDate, NoddiDateFormats.TIME);
  return {
    date: noddiFormatDate(startDate, startDateFormat),
    timeRange
  };
};

export const getBookingTimeWindowDisplayText = (options: BookingTimeWindowDisplayOptions) => {
  const { date, timeRange } = getBookingTimeWindowDisplayParts(options);
  return `${date}, ${timeRange}`;
};

export const mapToDeliveryWindow = (
  bookingTimeWindow: Pick<TimeWindowForDisplay, 'startsAt' | 'endsAt'> | null | undefined
) =>
  bookingTimeWindow
    ? {
        startsAt: bookingTimeWindow.startsAt,
        endsAt: bookingTimeWindow.endsAt
      }
    : undefined;
